import styles from './dashboard.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';
import APIDetailsSection from 'src/components/APIDetailsSection';
import FeaturesLinksSection from 'src/components/FeaturesLinksSection';
import TestimonialsSection from 'src/components/TestimonialsSection';
import UptimeSplash from 'src/components/UptimeSplash';

import ImgCoding from 'src/images/img-coding.jpg';
import ImgCoding2x from 'src/images/img-coding@2x.jpg';
import ImgCoding3x from 'src/images/img-coding@3x.jpg';
import IconAPI from 'src/images/icon-api.png';
import IconAPI2x from 'src/images/icon-api@2x.png';
import IconAPI3x from 'src/images/icon-api@3x.png';

const Hero = (props) => (
  <div styleName='hero'>
      <Container>
          <div styleName='text-container'>
              <RetinaImage srcSet={[IconAPI, IconAPI2x, IconAPI3x]} />
              <div className='h1 mt-2'>API</div>
              <div className='h2 text-blue'>Unleash your data.</div>
              <div styleName='message'>
                  Gain even more insight. Use the API to pull Galleon's clean,
                  normalized shipping data into your own data warehouse for
                  advanced analysis.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgCoding, ImgCoding2x, ImgCoding3x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);

export default (props) => (
  <div>
      <Hero />
      <APIDetailsSection />
      <TestimonialsSection />
      <UptimeSplash />
      <FeaturesLinksSection />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/features/api.js